import { NoteCreationDto } from '../dtos/note.dto';
import { Note, NoteCreation } from '../models/note';
import { dateMapper } from './date.mapper';
import { userMapper } from './user.mapper';

/**
 * Map data to model from DTO.
 * @param {object} dto DTO.
 * @returns {Note}
 */
function fromDto(dto) {
  return new Note({
    id: dto.id,
    registrationId: dto.registration_id,
    typeId: dto.type_id,
    userId: dto.user_id,
    createDate: dateMapper.fromDto(dto.create_date),
    editDate: dateMapper.fromDto(dto.edit_date),
    isActive: dto.active,
    user: dto.user != null ? userMapper.fromDto(dto.user) : null,
    note: dto.note,
  });
}

/**
 * Map model to creation DTO.
 * @param {NoteCreation} data Model.
 * @returns {NoteCreationDto}
 */
function toCreateDto(data) {
  return {
    note: data.note,
  };
}

export const noteMapper = {
  fromDto,
  toCreateDto,
};
